<template lang="pug">
#detail.i_pb_10
  section.container.i_pt_16.i_pt_sm_6
    .row
      .col-md-6
        .i_mb_3.friendly-btn
          audio-guide(
            :sourcefast="audioguide.fast",
            :sourcedefault="audioguide.default",
            :sourceslow="audioguide.slow",
            :key="question.FAQID"
          )
          theme
        h1.font-color {{ question.FAQTitle }}
        p.i_body_l.i_pl_4.i_ptb_1.i_mt_3.d-none.d-md-block.font-color {{ question.FAQBrief }}
      .col-md-6.i_mt_sm_6
        .img(
          v-if="question",
          :style="{ backgroundImage: 'url(' + question.FAQContentImage + ')' }"
        )
      .col-md-6.i_mt_sm_8.d-md-none 
        p.i_body_l.i_pl_4.i_ptb_1 {{ question.FAQBrief }}
    .row.i_mt_8
      .col-12.content.i_body_l.i_mt_4.i_mt_md_2.font-color(v-html="question.FAQContent")
      .col-12.i_mt_8.i_mb_10.d-flex.justify-content-center
        router-link.btn_square.contact_btn.font-btn-color(
          v-if="true",
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }"
        ) 聯絡我們
        a.btn_square.btn_yellow.ensure_btnfont-btn-color(
          v-if="question.WebInsured == 1",
          :href="question.WebInsuredUrl",
          target="_blank"
        ) 網路投保

  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_2.font-til-color 延伸閱讀
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4.question-color(
        v-for="extendQuestion in extendQuestions"
      )
        question(:question="extendQuestion", @changeQuestion="changeQuestion")
    .see_more_btn.sm.btn_yellow.text-center.i_mt_10.font-btn-color(@click="toFAQ") 看更多
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Question from "@/components/common/Question";
import AudioGuide from "@/components/customer_service/AudioGuide";
import Theme from "@/components/customer_service/Theme";
import { getFAQDetail } from "@/json/FAQ";

export default {
  name: "CustomerServiceFAQDetail",
  components: {
    "custom-footer": CustomFooter,
    question: Question,
    "audio-guide": AudioGuide,
    theme: Theme
  },
  data() {
    return {
      FAQDetail: [],
      extendQuestions: [],
      question: {},
      audioguide: {},
      id: this.$route.query.id,
      audioplay: true
    };
  },
  created() {
    this.getDetailData();
  },
  methods: {
    getDetailData() {
      this.extendQuestions = [];
      getFAQDetail().then((response) => {
        this.FAQDetail = response.data;
        for (let index in this.FAQDetail.FAQDeatilList) {
          let detail = this.FAQDetail.FAQDeatilList[index];
          if (detail.FAQID == this.id) {
            this.question = detail;
            this.audioguide = detail.AudioGuide;
            break;
          }else if(this.id == 391){
            document.location.href="https://www.tmnewa.com.tw/b2C_V3/";
          }
        }
        this.getExtendData();
      });
    },
    getExtendData() {
      this.extendQuestions = [];
      for (let index in this.FAQDetail.FAQDeatilList) {
        let detail = this.FAQDetail.FAQDeatilList[index];
        if (detail.FAQID == this.question.FAQExtendID_1) {
          this.extendQuestions.push(detail);
        }
        if (detail.FAQID == this.question.FAQExtendID_2) {
          this.extendQuestions.push(detail);
        }
        if (detail.FAQID == this.question.FAQExtendID_3) {
          this.extendQuestions.push(detail);
        }
        if (detail.FAQID == this.question.FAQExtendID_4) {
          this.extendQuestions.push(detail);
        }
      }
    },
    changeQuestion(id) {
      this.id = id;
      this.getDetailData();
      window.scrollTo(0, 0);
    },
    toFAQ() {
      this.$router.push({ name: "CustomerServiceFAQ" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/detail/detail";
#detail{
   background-color: var(--background-color) !important;
}
.btn_square {
  margin-left: initial;
  margin-right: initial;
}

.contact_btn {
  margin-right: 10px;
}

.ensure_btn {
  margin-left: 10px;
}

h1 {
  color: $color_black_title;
}

.friendly-btn{
  display: flex;
  flex-direction: row;
}

.font-color{
  color: var(--font-color) !important;
}

.font-til-color{
  color: var(--font-til-color) !important;
}

.font-btn-color{
  color: var(--font-btn-color) !important;
}
</style>
<style lang="scss">
.question-color{
  h5{
    color: var(--font-color) !important;
  }

  .arrow_bottom_g{
    color: var(--font-color) !important;
  }

  p{
    color: var(--font-color) !important;
  }
}

@media (max-width: 991px) {
  .friendly-btn{
      flex-direction: column !important;
  }
  .theme-mode{
    margin-left: 0 !important;
    margin-top: 0.9375rem;
  }
}

@media (max-width: 767px){
  .friendly-btn{
      margin-bottom: 0 !important;
  }
}
</style>
